import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Grid,
  Link,
  Stack,
  Typography,
  IconButton
} from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import FooterDropdown from './FooterDropdown';

const Footer = () => {
  const sections = {
    marketplace: {
      'All NFTs': 'Explore our vast collection of NFTs across all categories. Find unique digital artworks, collectibles, music, and more. Browse by price, creator, or collection to discover your next digital treasure.',
      'Art': 'Discover digital masterpieces from renowned artists and emerging talents. Our art collection includes paintings, illustrations, 3D art, and generative pieces that push the boundaries of digital creativity.',
      'Collectibles': 'Dive into our exclusive collection of digital collectibles. From limited edition series to one-of-a-kind items, find rare pieces that appreciate in value over time.',
      'Music': 'Experience the future of music ownership with our music NFTs. Collect exclusive tracks, albums, and audio experiences from your favorite artists and emerging musicians.'
    },
    account: {
      'Profile': 'Your digital portfolio hub. View your collected NFTs, manage your listings, track your trading history, and customize your profile to showcase your collection to the world.',
      'Favorites': 'Keep track of NFTs that catch your eye. Save items for later, create custom lists, and get notified when prices change for your favorite pieces.',
      'Watchlist': 'Monitor market trends and track specific NFTs. Set price alerts, follow creator drops, and stay updated on the latest activities of your watched items.',
      'Settings': 'Customize your Castle NFT experience. Manage your notification preferences, security settings, payment methods, and display options.'
    },
    company: {
      'About': 'Learn about Castle NFT\'s mission to revolutionize digital ownership. Discover our vision, team, and commitment to building the future of NFT trading.',
      'Careers': 'Join our dynamic team and help shape the future of digital assets. View open positions across engineering, design, marketing, and customer support.',
      'Blog': 'Stay informed with the latest news, market insights, creator spotlights, and platform updates. Learn about NFT trends and get expert tips.',
      'Help Center': 'Get comprehensive support for all your needs. Access guides, FAQs, trading tips, and connect with our support team for assistance.'
    }
  };

  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 6,
        background: 'linear-gradient(0deg, rgba(0, 245, 255, 0.1) 0%, rgba(15, 22, 36, 0) 100%)',
        borderTop: '1px solid rgba(0, 245, 255, 0.2)',
        mt: 'auto'
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box
              component={RouterLink}
              to="/"
              sx={{
                display: 'inline-block',
                mb: 2
              }}
            >
              <img 
                src="/logo.png" 
                alt="Castle NFT Logo" 
                style={{ 
                  height: '40px',
                  filter: 'drop-shadow(0 0 10px rgba(0, 245, 255, 0.5))'
                }}
              />
            </Box>
            <Typography 
              variant="body2" 
              sx={{ 
                color: '#8F9BB7',
                maxWidth: 300 
              }}
            >
              The premier marketplace for NFTs. Buy, sell, and discover exclusive digital items.
            </Typography>
          </Grid>

          <Grid item xs={12} md={8}>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={4}>
                <Typography 
                  variant="subtitle1" 
                  sx={{ 
                    color: '#00F5FF',
                    mb: 2,
                    fontWeight: 600
                  }}
                >
                  Marketplace
                </Typography>
                <Stack spacing={2}>
                  {Object.entries(sections.marketplace).map(([title, content]) => (
                    <FooterDropdown key={title} title={title} content={content} />
                  ))}
                </Stack>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography 
                  variant="subtitle1" 
                  sx={{ 
                    color: '#00F5FF',
                    mb: 2,
                    fontWeight: 600
                  }}
                >
                  Account
                </Typography>
                <Stack spacing={2}>
                  {Object.entries(sections.account).map(([title, content]) => (
                    <FooterDropdown key={title} title={title} content={content} />
                  ))}
                </Stack>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Typography 
                  variant="subtitle1" 
                  sx={{ 
                    color: '#00F5FF',
                    mb: 2,
                    fontWeight: 600
                  }}
                >
                  Company
                </Typography>
                <Stack spacing={2}>
                  {Object.entries(sections.company).map(([title, content]) => (
                    <FooterDropdown key={title} title={title} content={content} />
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Box 
              sx={{ 
                pt: 4,
                mt: 4,
                borderTop: '1px solid rgba(0, 245, 255, 0.2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 2
              }}
            >
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#8F9BB7'
                }}
              >
                2025 Castle NFT. All rights reserved.
              </Typography>
              
              <Stack direction="row" spacing={1}>
                <IconButton
                  href="https://x.com/Castleexchange_"
                  target="_blank"
                  rel="noopener noreferrer"
                  size="small"
                  sx={{
                    color: '#8F9BB7',
                    transition: 'all 0.3s ease-in-out',
                    '&:hover': {
                      color: '#00F5FF',
                      '& svg': {
                        filter: 'drop-shadow(0 0 5px rgba(0, 245, 255, 0.5))'
                      }
                    }
                  }}
                >
                  <TwitterIcon />
                </IconButton>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
